module.exports = __webpack_public_path__ + "static/media/utrecht-placuta.d9088c63.png";